import { ScheduleRuleSkipReason } from "@common/schemas/domains/accounting/scheduleRuleOutcome.schema";

export const SCHEDULE_RULE_SKIP_REASON_COPY: Record<
    ScheduleRuleSkipReason,
    string
> = {
    [ScheduleRuleSkipReason.accountTypeMismatch]:
        "The transaction's account type doesn't fit this schedule.",
    [ScheduleRuleSkipReason.linkedInvoiceSchedule]:
        "The matched invoice already has its own schedule.",
    [ScheduleRuleSkipReason.lockedPeriod]:
        "Part of the schedule falls in a locked period.",
    [ScheduleRuleSkipReason.missingTemplateAccounts]:
        "The schedule's accounts aren't available for this entity.",
    [ScheduleRuleSkipReason.noAccrualLedger]:
        "The entity doesn't have an Accrual ledger.",
    [ScheduleRuleSkipReason.notMoneyIn]:
        "Only money-in transactions can be scheduled.",
    [ScheduleRuleSkipReason.notMoneyOut]:
        "Expense schedules can only go on money-out transactions.",
    [ScheduleRuleSkipReason.policyUnsupported]:
        "Rules can't apply this policy to transactions yet.",
    [ScheduleRuleSkipReason.templateUnavailable]:
        "The schedule was archived or deleted.",
    [ScheduleRuleSkipReason.unexpected]:
        "An unexpected error blocked it. Run the rule again or contact support.",
};
